export const baseState = {
    showMobileMenu: false,
    showSearchResultDropdown: false,
    showCart: false,
    showDeliveryDatesDropdown: false,
    showAddressDropdown: false,
    showUserDropdown: false,
    hasRegionFromAddress: false,
    showAutoRegionNotification: false,
    showApartmentNumberHelpModal: false,
    showCheckoutValidationNotification: false,
    isTablet: false,
    isMobile: false,
    isApp: false,
    categoryListPageActiveTab: 0,
    showCvcInput: false,
    showDeliveryDateChangeNotification: false,
    showNetworkErrorPage: false,
}

const resetState = (state) => ({
    ...state,
    ...baseState,
    isMobile: state.isMobile,
    isApp: state.isApp,
    isTablet: state.isTablet,
    showDeliveryDateChangeNotification: state.showDeliveryDateChangeNotification,
})

export default function reducer(
    state = {
        ...baseState,
    },
    action
) {
    switch (action.type) {
        case 'TOGGLE_MOBILE_MENU':
            return {
                ...resetState(state),
                showMobileMenu:
                    action.payload != undefined ? action.payload : !state.showMobileMenu,
            }
        case 'CHANGE_SEARCH_VALUE':
            return {
                ...state,
                showSearchResultDropdown: !!action.payload,
            }
        case 'TOGGLE_SEARCH_DROPDDOWN':
            return {
                ...resetState(state),
                showSearchResultDropdown:
                    action.payload != undefined ? action.payload : !state.showSearchResultDropdown,
            }
        case 'TOGGLE_CART':
            return {
                ...resetState(state),
                showCart: action.payload != undefined ? action.payload : !state.showCart,
            }
        case 'TOGGLE_DELIVERY_DATE_DROPDOWN':
            return {
                ...resetState(state),
                showDeliveryDatesDropdown:
                    action.payload != undefined ? action.payload : !state.showDeliveryDatesDropdown,
            }
        case 'TOGGLE_USER_DROPDOWN':
            return {
                ...resetState(state),
                showUserDropdown:
                    action.payload != undefined ? action.payload : !state.showUserDropdown,
            }
        case 'TOGGLE_ADDRESS_DROPDOWN':
            return {
                ...resetState(state),
                showAddressDropdown:
                    action.payload != undefined ? action.payload : !state.showAddressDropdown,
            }
        case 'HIDE_DROPDOWNS':
            return resetState(state)
        case 'CLOSE_AUTO_REGION_NOTIFICATION':
            return { ...state, showAutoRegionNotification: false }
        case 'CLOSE_CHECKOUT_VALIDATION_NOTIFICATION':
            return { ...state, showCheckoutValidationNotification: false }
        case 'ORDER_VALIDATION_FAILED':
            return { ...state, showCheckoutValidationNotification: true }
        case 'GEOFENCE_REGION':
            return {
                ...state,
                showAutoRegionNotification: !state.hasRegionFromAddress,
            }
        case 'SET_ACTIVE_ADDRESS':
            return {
                ...state,
                showAutoRegionNotification: false,
                hasRegionFromAddress: true,
            }
        case 'STORE_ADDRESS':
            return {
                ...state,
                showAutoRegionNotification: false,
                hasRegionFromAddress: true,
            }
        case 'TOGGLE_APARTMENT_NUMBER_HELP_MODAL':
            return {
                ...state,
                showApartmentNumberHelpModal:
                    action.payload != undefined
                        ? action.payload
                        : !state.showApartmentNumberHelpModal,
            }
        case 'TOGGLE_IS_TABLET':
            return {
                ...state,
                isTablet: action.payload,
            }
        case 'SET_CATEGORY_LIST_PAGE_ACTIVE_TAB':
            return {
                ...state,
                categoryListPageActiveTab: action.payload,
            }
        case 'TOGGLE_IS_MOBILE':
            return {
                ...state,
                isMobile: action.payload,
            }
        case 'IS_APP':
            return {
                ...state,
                isApp: action.payload,
            }
        case 'TOGGLE_CVC_INPUT':
            return {
                ...state,
                showCvcInput: action.payload,
            }
        case 'SHOW_DELIVERY_DATE_CHANGED_NOTIFICATION':
            return {
                ...state,
                showDeliveryDateChangeNotification: true,
            }
        case 'CLOSE_DELIVERY_DATE_CHANGED_NOTIFICATION':
            return {
                ...state,
                showDeliveryDateChangeNotification: false,
            }
        case 'TOGGLE_SHOW_NETWORK_ERROR_PAGE':
            return {
                ...state,
                showNetworkErrorPage: action.payload,
            }
        default:
            return state
    }
}
